/*
 * $Id:: rootReducer.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import authReducer from '../pages/AuthenticatedPage/authenticationSlice';
import correspondenceDetailsReducer from '../pages/CorrespondenceDetails/correspondenceDetailsSlice';
import correspondenceReducer from '../pages/CorrespondencePage/correspondenceSlice';
import accountReducer from '../pages/MyAccountPage/accountSlice';
import finalizedApplicationsReducer from '../pages/MyApplicationsPage/finalizedApplicationsSlice';
import draftApplicationsReducer from '../pages/MyDraftsPage/draftApplicationsSlice';
import paymentHistoryReducer from '../pages/PaymentHistory/paymentHistorySlice';
import paymentsReducer from '../pages/PaymentsPage/paymentsSlice';
import signaturesReducer from '../pages/SignaturesPage/signaturesSlice';
import ssoReducer from '../pages/SSOPage/ssoSlice';
import globalsReducer from './globalsSlice';
import literalsReducer from './literalsSlice';
import notificationsReducer from './notificationsSlice';

const rootReducer = {
    account: accountReducer,
    auth: authReducer,
    correspondence: correspondenceReducer,
    correspondenceDetails: correspondenceDetailsReducer,
    draftApplications: draftApplicationsReducer,
    finalizedApplications: finalizedApplicationsReducer,
    globals: globalsReducer,
    literals: literalsReducer,
    notifications: notificationsReducer,
    paymentHistory: paymentHistoryReducer,
    payments: paymentsReducer,
    signatures: signaturesReducer,
    sso: ssoReducer,
};

export default rootReducer;
